export const imgLoader = () => {
    document.querySelectorAll('figure.image:not(.loaded) img')
        .forEach((img) => {
            if (img.complete) {
                img.closest('figure').classList.add('loaded');
            } else {
                img.addEventListener('load', (e) => {
                    e.currentTarget.closest('figure').classList.add('loaded');
                });
            }
        });
}

let videoObserver;
if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
    videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;
            if (entry.isIntersecting) {
                // Swap data-src to src for true lazy loading if provided
                const sources = video.querySelectorAll('source[data-src]');
                let loadNeeded = false;
                sources.forEach(source => {
                    source.src = source.dataset.src;
                    source.removeAttribute('data-src');
                    loadNeeded = true;
                });

                if (loadNeeded) {
                    video.load();
                }

                // Play video when in view
                const playPromise = video.play();
                if (playPromise !== undefined) {
                    playPromise.catch(() => { /* Ignore auto-play blocked errors */ });
                }
            } else {
                // Pause video when out of view
                video.pause();
            }
        });
    }, {
        rootMargin: "200px 0px", // Start loading/playing slightly before it enters screen
        threshold: 0
    });
}

export const videoLoader = () => {
    // Process standard videos
    document.querySelectorAll('figure.video:not(.loaded) video, video.lazy-video:not(.loaded)')
        .forEach((video) => {
            if (videoObserver) {
                videoObserver.observe(video);
            }

            if (video.readyState >= 3) {
                video.closest('figure.video')?.classList.add('loaded');
            } else {
                video.addEventListener('canplay', (e) => {
                    e.currentTarget.closest('figure.video')?.classList.add('loaded');
                });
            }

            video.classList.add('loaded');
        });

    // Process Swiper clones (duplicates) specifically as they copy the .loaded class
    document.querySelectorAll('.swiper-slide-duplicate video:not(.observed-clone)')
        .forEach((video) => {
            if (videoObserver) {
                videoObserver.observe(video);
                video.classList.add('observed-clone');
            }
        });
}

export const scrollHandler = () => {
    document.querySelectorAll('[data-scroll]').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = el.getAttribute('href');
            const target = document.querySelector(targetId);

            if (target) {
                target.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        });
    });
}

export const expandableHandler = () => {
    const handle = (e) => {
        const swiperContainer = e.target;
        const swiper = swiperContainer.swiper || e.detail?.[0];

        if (swiper && swiper.activeIndex > 0) {
            const container = swiperContainer.closest('.container.expandable:not(.expanded');
            if (container) {
                container.classList.add('expanded');
                container.classList.remove('half', 'left', 'right');
            }
            const gallery = swiperContainer.closest('.hide-prev');
            if (gallery) {
                gallery.classList.remove('hide-prev');
            }
        }
    };

    document.addEventListener('swiperslidechange', handle, true);
}